<template>
  <b-modal
    ref="cart-items"
    hide-footer
    centered
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <b-row>
      <b-col md="1">
        <h6>
          <font-awesome-icon
            :icon="['fa', 'exclamation-circle']"
            class="text-danger"
          />
        </h6>
      </b-col>
      <b-col md="11" class="pl-0">
        <h6 class="fw-normal">Add items from previous session?</h6>
        <p style>
          {{ cart_items.length }} products were found in a previous billing
          session for the customer
        </p>
      </b-col>
    </b-row>
    <b-row class="overflow-auto item-list" style="max-height: 50vh">
      <b-col offset-md="1" class="pl-0">
        <ul class="list-unstyled" v-for="item in cart_items" :key="item.id">
          <li v-text="item.item_name" />
        </ul>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end mt-3">
      <b-button
        variant="danger"
        class="mr-1"
        :disabled="$loading"
        @click="discardItems"
        id="discard-items"
      >
        <span v-if="!$loading || btnAction != 'discard'">Discard Items</span>
        <b-spinner small v-if="$loading && btnAction == 'discard'" />
      </b-button>
      <b-button
        class="ml-1"
        variant="primary"
        @click="addItems"
        :disabled="$loading"
        id="add-items-to-cart"
      >
        <span v-if="!$loading || btnAction != 'add'">Add items to cart</span>
        <b-spinner small v-if="$loading && btnAction == 'add'" />
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "existing-cart-items",
  props: ["open", "cart_items"],
  data() {
    return {
      btnAction: "",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  watch: {
    open() {
      if (this.open) {
        this.$refs["cart-items"].show();
      } else {
        this.$refs["cart-items"].hide();
      }
    },
  },

  methods: {
    addItems() {
      this.btnAction = "add";
      this.$loading = true;
      this.$store.dispatch("billing/cartDetails").then(() => {
        this.$loading = false;
        this.closeModal();
      });
    },
    discardItems() {
      this.btnAction = "discard";
      this.$loading = true;
      let postData = {
        url: "/cart-details",
        cart_items: JSON.stringify(this.cart_items),
      };
      let data = Object.assign(postData, this.customerData);
      axios.post(data.url, data).then((res) => {
        this.$store.commit("billing/saveCartDetails", res.data);
        this.$store.commit(
          "billing/saveHoldBillCount",
          res.data.hold_bill_count
        );
        this.$loading = false;
        this.closeModal();
      });
    },
    closeModal() {
      this.btnAction = "";
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  width: 380px !important;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 380px !important;
  }
}

.item-list {
  @include custom-scrollbar();
}

.theme-dark {
  p {
    color: #808080 !important;
  }
  h6 {
    color: #ffffff !important;
    font-weight: normal;
  }
  li {
    color: #c0c0c0 !important;
  }
}
.theme-light {
  p {
    color: #808080;
  }
}
</style>
